import { useNavigate } from "react-router-dom"
import { mapCardStatusDetail } from "../../../utils/tb/cardStatusDetail"
import * as S from "../styled"

type Props = {
  statusDetail?: string
  originalState: any
}

export function CardError({ statusDetail, originalState }: Props) {
  const nav = useNavigate()
  const message = mapCardStatusDetail(statusDetail)

  return (
    <S.ErrorWrap>
      <h2>Pagamento recusado</h2>
      <p>{message}</p>
      <S.ErrorButtons>
        <S.Button
          onClick={() =>
            nav("/payment", {
              state: { ...originalState, preselectMethod: "credit" },
            })
          }
        >
          Tentar outro cartão
        </S.Button>
        <S.Button
          $outlined
          onClick={() =>
            nav("/payment", {
              state: { ...originalState, preselectMethod: "pix" },
            })
          }
        >
          Pagar com PIX
        </S.Button>
      </S.ErrorButtons>
    </S.ErrorWrap>
  )
}
